import { AppLayout } from "../../components/layout/Header";
import TheHubApp from "../../components/theHub/TheHubApp";
import { useAuth } from "../../js/hooks/useAuth";
import { useDesk } from "../../js/hooks/useDesk";
import { canUseTheHub, ensureTheHub } from "../../js/theHub";

export default function TheHubPage() {
  const { session, role } = useAuth();
  const desk = useDesk();
  ensureTheHub();

  if (!canUseTheHub(session)) {
    return (
      <AppLayout variant={desk.variant === "broker" ? "broker" : desk.variant === "admin" ? "admin" : "agent"}>
        <article className="the-hub">
          <h1>The Hub</h1>
          <p>The Hub is a private space for signed-in brokers and agents.</p>
        </article>
      </AppLayout>
    );
  }

  const variant = role === "admin" ? "admin" : role === "broker" || desk.variant === "broker" ? "broker" : "agent";
  return (
    <AppLayout variant={variant}>
      <TheHubApp session={session} basePath={desk.hub || `${desk.base}/hub`} />
    </AppLayout>
  );
}
